import { useCallback } from 'react';
import { useFieldArray } from 'react-hook-form';
import { nanoid } from 'nanoid';

import { type BuildFormControl } from '../../type';

export const useSubjectiveAnswers = ({
  control,
  index,
}: {
  control: BuildFormControl;
  index: number;
}) => {
  const { fields, append, remove, insert } = useFieldArray({
    control,
    name: `quizList.${index}.subjectiveData.answerList`,
  });

  const handleAdd = useCallback(() => {
    append({ key: nanoid(8), text: '' });
  }, [append]);

  const handleInsert = useCallback(
    (answerIndex: number) => {
      insert(answerIndex, { key: nanoid(8), text: '' });
    },
    [insert],
  );

  const handleRemove = useCallback(
    (index: number) => {
      remove(index);
    },
    [remove],
  );

  return {
    handleAdd,
    handleInsert,
    handleRemove,
    answers: fields,
  };
};
